'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMeals(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M3.364 6.97L5.14 5.204 1.255 1.347a.633.633 0 00-1.01.168 2.496 2.496 0 00.49 2.846L3.363 6.97zm4.255-1.13c.96.443 2.31.131 3.307-.861 1.199-1.192 1.431-2.902.509-3.82-.917-.91-2.636-.686-3.841.506-.998.992-1.312 2.334-.866 3.289l-5.686 5.654a.619.619 0 000 .88c.244.244.64.244.885 0l3.884-3.85 3.879 3.856c.245.244.64.244.885 0a.619.619 0 000-.88L6.696 6.758l.923-.918z", id: "Meals__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Meals__svg__a" })))));
}

module.exports = SvgMeals;
//# sourceMappingURL=Meals.js.map
